export const normalizeTimestamp = (timestamp) => {
  const value = Number(timestamp);
  if (!value) return 0;
  return value > 9999999999 ? value : value * 1000;
};

export const getMessageDayKey = (timestamp) => {
  const date = new Date(normalizeTimestamp(timestamp));
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
};

export const getDateDividerLabel = (timestamp) => {
  const date = new Date(normalizeTimestamp(timestamp));
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime();
  const messageDay = getMessageDayKey(timestamp);

  if (messageDay === today) return "Today";
  if (messageDay === yesterday) return "Yesterday";

  return date.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};